<template>
    <div
        class="headbar"
        :style="{
            background: backgroundColor,
            height: (text == '来程订票' || text == '返程订票') && isAdd ? '3rem' : '2.63rem'
        }"
    >
        <div class="header-item">
            <div class="headbar-left">
                <span class="cricle"></span>
                <span>{{ text }}</span>
            </div>
            <div
                class="headbar-right"
                v-if="(text == '来程订票' || text == '返程订票') && isAdd"
                @click="handleAdd"
            >
                <span :class="{ disabled }">行程收集</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    // 未选择交通方式或选择了自驾时，订票入口不可点击
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleAdd () {
      if (this.disabled) return
      this.$emit('add')
    }
  }
}
</script>

<style lang="scss" scoped>
.headbar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    height: 3rem;
    padding: 0.41rem 0.33rem;
    border-radius: 0.41rem 0.41rem 0rem 0rem;
    .header-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .headbar-left {
        display: flex;
        align-items: center;
        .cricle {
            display: inline-block;
            width: 0.21rem;
            height: 0.21rem;
            background: #ffffff;
            border-radius: 100%;
            margin-right: 0.21rem;
        }
        span {
            font-size: 0.57rem;
            font-weight: 500;
            color: #ffffff;
        }
    }
    .headbar-right {
        display: flex;
        align-items: center;
        > span {
            display: flex;

            align-items: center;
            gap: 0.1rem;
            padding: 0.2rem 0.4rem;
            border-radius: 6.1875rem;
            background: #0072f5;
            color: #fff;
        }
        .disabled {
            background: #98c6fa !important;
            color: #f2f7ff !important;
        }
    }
}
</style>
